export const EXHIBITION_USER_LIST_CONSTANTS = {
    STATUS_PENDING: 0,
    STATUS_EXPIRED: 3,
    STATUS_ACCEPTED: 1
};